import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule }
	from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { MatIconButton } from '@angular/material/button';

import { NumberPipe } from '../../../../shared/pipes/number.pipe';
import { ProductDetails } from '../../../models/need4steel';

@Component({
	selector: 'copo-need4steel-product-details',
	templateUrl: './product-details.component.html',
	styleUrl: './product-details.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		TranslateModule,
		NumberPipe,
		MatIconModule,
		NgClass,
		NgIf,
		NgFor,

		MatDialogModule,
		MatIconButton
	]
})
export class DialogProductDetailsComponent {
	toNumber = Number;

	constructor(

		@Inject(MAT_DIALOG_DATA) private readonly data: {
			productDetails: Map<string, ProductDetails>;
			totalPrice: string;
		},
	) {}

	getProductDataMap() {
		return Array.from(this.data.productDetails);
	}

	getTotalPrice() {
		return this.data.totalPrice;
	}
}
